import { render, staticRenderFns } from "./user_discount_record.vue?vue&type=template&id=c75a35dc&"
import script from "./user_discount_record.vue?vue&type=script&lang=js&"
export * from "./user_discount_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports